import React from 'react';
import SouthingtonEnhanced from '../components/SouthingtonEnhanced';

const SouthingtonPage = () => {
  return (
    <div className="page-container">
      <SouthingtonEnhanced />
    </div>
  );
};

export default SouthingtonPage;